import { action } from '@ember/object';
import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';

import AvatarOrInitialsComponent from 'webapp/components/avatar-or-initials';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class CommonPopupDemoLimitationComponent extends PopupInnerModalComponent<PopupData.None> {
	@service('account') declare accountService: Service.Account;
	@service('current-user') declare currentUserService: Service.CurrentUser;
	@service('model-manager/users') declare mmUsersService: Service.ModelManager.Users;

	trackingType = 'limitation';

	get accountOwner() {
		if (this.accountService.isClient) {
			return this.mmUsersService.agencyAdminRecordForClientSpace;
		} else {
			return this.accountService.accountOwner;
		}
	}

	get isAgencyUserInPaidClientSpace() {
		return this.currentUserService.isAgencyUserInPaidClientSpace;
	}

	@action
	redirect() {
		this.accountService.openAccountAppClientManagerEdit(this.accountService.id);
	}
	<template>
		<div class="content">
			<CommonUiIconComponent @name="Clients" @size="2xl" @class="header-icon" />
			<h2>An account subscription is required</h2>
			<hr class="wider" />
			{{#if this.isAgencyUserInPaidClientSpace}}
				<p>Please contact your account manager for help.</p>
				<div class="account-owner-banner">
					<AvatarOrInitialsComponent
						@name={{this.accountOwner.name}}
						@avatar={{this.accountOwner.avatar}}
					/>
					<div class="info">
						<div class="name">
							<strong>{{this.accountOwner.name}}</strong>
							(Account owner)
						</div>
						<div class="email">{{this.accountOwner.email}}</div>
					</div>
				</div>
			{{else}}
				<p>
					To invite account users, please update account access settings.
					<a
						class="learn-more"
						target="_blank"
						href="https://help.databox.com/databox-solutions-partner-program"
					>
						Learn more
					</a>
				</p>
				<div class="controls2 controls2--center">
					<SubmitButtonComponent
						@text="Change account access"
						@size="big"
						@theme="blue-outlined"
						@onTrigger={{this.redirect}}
					/>
				</div>
			{{/if}}
		</div>
	</template>
}
